import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
const baseUrl = '  https://election.mgmebuild.com/api/';


const DISTRICTS = [
  'Chennai',
  'Chengalpattu',
  'Kancheepuram',
  'Thiruvallur',
  'Vellore',
  'Ranipet',
  'Tiruvannamalai',
  'Villupuram',
  'Cuddalore',
  'Mayiladuthurai',
  'Nagapattinam',
  'Thanjavur',
  'Tiruvarur',
  'Trichy',
  'Karur',
  'Perambalur',
  'Ariyalur',
  'Pudukkottai',
  'Madurai',
  'Theni',
  'Dindigul',
  'Virudhunagar',
  'Ramanathapuram',
  'Sivaganga',
  'Thoothukudi',
  'Tirunelveli',
  'Kanyakumari',
  'Salem',
  'Namakkal',
  'Erode',
  'Coimbatore',
  'Tiruppur',
  'Krishnagiri'
];

function Register() {
  const [formData, setFormData] = useState({
    username: "",
    mobile: "",
    district: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const submitForm = async () => {
    try {
      await axios.post(`${baseUrl}register/`, formData);

      Swal.fire({
        title: "Registered Successfully",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });

      setFormData({ mobile: "", district: "", password: "" });

    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err.response?.data?.message || "Registration failed",
        icon: "error",
      });
    }
  };

  return (
    <section className="container mt-4">
  <h3
    className="text-center"
    style={{ color: "white", backgroundColor: "#0dcaf0" }}
  >
    <i
      className="fa-solid fa-user-plus"
      aria-hidden="true"
      style={{ color: "red" }}
    ></i>{" "}
    User Registration
  </h3>

  <div className="row mt-4">
    <form>
      <div className="table-responsive">
        <table className="erp-table-modern">
          <tbody>
            {/* Username */}
            <tr style={{ backgroundColor: "#1bc5ce", color: "white" }}>
              <td>User Name :</td>
              <td>
                <input
                  type="text"
                  className="no-comma"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                />
              </td>
            </tr>

            {/* Mobile */}
            <tr style={{ backgroundColor: "#1bc5ce", color: "white" }}>
              <td>Mobile Number :</td>
              <td>
                <input
                  type="number"
                  className="no-comma"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                />
              </td>
            </tr>

            {/* District */}
            <tr style={{ backgroundColor: "#1bc5ce", color: "white" }}>
              <td>District :</td>
              <td>
                <select
                  className="no-comma"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                >
                  <option value="">Select District</option>
                  {DISTRICTS.map((d, i) => (
                    <option key={i} value={d}>
                      {d}
                    </option>
                  ))}
                </select>
              </td>
            </tr>

            {/* Password */}
            <tr style={{ backgroundColor: "#1bc5ce", color: "white" }}>
              <td>Password :</td>
              <td>
                <input
                  type="password"
                  className="no-comma"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                />
              </td>
            </tr>

            {/* Submit */}
            <tr>
              <td colSpan="2" className="text-center">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={submitForm}
                >
                  Register
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
  </div>
</section>

  );
}

export default Register;
